<template>
  <Component
    :is="componentType"
    :class="['UIButtonText', `UIButtonText--theme-${theme}`]"
    @submit.prevent=""
    @click="handleClick"
    :disabled="isDisabled"
    type="button"
  >
    <slot />
  </Component>
</template>

<script lang="ts" setup>
import { computed, PropType, useAttrs } from 'vue'

const props = defineProps({
  theme: {
    type: String as PropType<'primary' | 'secondary'>,
    default: 'primary',
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['click'])

const componentType = computed(() => {
  const attrs = useAttrs()
  if (attrs.to) {
    return 'router-link'
  }
  if (attrs.href) {
    return 'a'
  }

  return 'button'
})

const handleClick = (event: MouseEvent) => {
  if (props.isDisabled) {
    event.preventDefault()
    event.stopPropagation()
    return
  }
  emit('click', event)
}
</script>
<style scoped lang="scss">
.UIButtonText {
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;

  &:disabled {
    color: $color-ui-neutral-300;

    &:hover {
      color: $color-ui-neutral-300;
    }
  }

  &--theme-primary {
    color: $color-ui-accent-main;
    &:hover {
      color: $newcolor-primary-dark;
    }
  }

  &--theme-secondary {
    color: $newcolor-grey-500;
    &:hover {
      color: $newcolor-grey-400;
    }
  }
}
</style>
